<script setup lang="ts">
import { onMounted, provide } from "vue";

provide("mode", import.meta.env.MODE);

onMounted(() => {
  console.log(`✨ RAM Unify v${import.meta.env.RAM_APP_VERSION}`);
});
</script>

<template>
  <div class="h-full w-full font-inter">
    <router-view />
  </div>
</template>
